// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productList":"css-1TBc7ObM3n"};